import styled from 'styled-components';

export const UserAnswer = styled.div`
  & .answerSection {
    background: #fff;
    margin: 16px 0;
    font-size: 14px;
    font-weight: 500;
    color: rgb(0 0 0 / 87%);
    border-radius: 4px;
  }

  .answerPadding {
    padding: 10px 18px;

    .seemore_selected {
      color: #63b0a8;
    }

    span {
      line-height: 2;
    }
  }

  & .like {
    margin: 10px 0;
    font-size: 12px;
    color: #6e6e6e;
    font-weight: 500;
  }

  .message {
    line-height: 2;
  }

  .light {
    opacity: 0.6;
  }
`;

export const AnsweredTime = styled.h6`
  font-size: 12px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 48%);
  padding-bottom: 14px;
`;

export const AnsHelpful = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  padding-top: 18px;

  .helpFul {
    font-weight: 600;
    font-size: 13px;
  }

  img {
    width: 22px;
    height: 22px;
  }
`;

export const HelpfulCTA = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  transition: transform 0.2s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s;
  cursor: pointer;
  opacity: 0.6;

  &:hover {
    transform: scale(1.04);
  }

  @media (max-width: 720px) {
    cursor: default;
  }
`;

export const MostHelpfulRibbon = styled.div`
  background-color: #cef0de;
  text-align: center;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 600;
  color: #63b0a8;
  padding: 6px 22px 6px 18px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  position: relative;
  width: max-content;
  height: 30px;
  @media (max-width: 720px) {
    padding: 8px 22px 8px 10px;
    font-size: 10px;
  }

  img {
    width: 9px;
    height: 11px;
    margin-right: 4px;
  }

  &:after {
    content: '';
    position: absolute;
    height: 0;
    width: 0;
    border-width: 15px 8px;
    border-style: solid;
    border-color: #cef0de white #cef0de #cef0de;
    top: 0px;
    right: 0px;
  }
`;

export const AnswerTopSection = styled.div`
  display: flex;
  column-gap: 10px;
`;
export const UserImageIcon = styled.div`
  width: clamp(30px, 4vw, 42px);
  height: clamp(30px, 4vw, 42px);
  line-height: clamp(27px, 4vw, 39px);
  box-shadow: rgba(0, 109, 54, 0.12) 0px 2px 2px 0px;
  border: 1px solid rgba(94, 151, 145, 0.4);
  background-color: ${(props) => props.bg};
  border-radius: 50%;
  text-align: center;
  color: rgb(94, 151, 145);
  font-size: clamp(13px, 2vw, 13px);
  font-weight: 500;
  transition: all 0.1s cubic-bezier(0.6, -0.28, 0.735, 0.045) 0s;
  color: white;
  border-color: white;
  border-width: medium;

  &.group {
    width: 30px;
    height: 30px;
    line-height: 27px;
    position: ${(props) => (props.position == 0 ? 'static' : 'absolute')};
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
    left: ${(props) => props.position * 63}%;
    z-index: ${(props) => props.position + 1};
    background-color: ${(props) => props.bgColor};
  }
`;

export const UserImageIconGroup = styled.div`
  border: 1px solid rgba(94, 151, 145, 0.4);
  border-radius: 50%;
  text-align: center;
  color: rgb(94, 151, 145);
  font-size: clamp(13px, 2vw, 13px);
  font-weight: 500;
  margin: 10px 0px;
  transition: all 0.1s cubic-bezier(0.6, -0.28, 0.735, 0.045) 0s;
  color: white;
  border-color: white;
  border-width: medium;

  width: 30px;
  height: 30px;
  line-height: 27px;
  position: ${(props) => (props.position == 0 ? 'static' : 'absolute')};
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
  left: ${(props) => props.position * 63}%;
  z-index: ${(props) => props.position + 1};
  background-color: ${(props) => props.bgColor};
`;

export const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
  color: rgb(0 0 0 / 60%);
  row-gap: 3px;
  text-transform: capitalize;

  & .highlight {
    color: #ef4e5e;
    margin-left: 4px;
    cursor: pointer;
  }
`;

export const UserImagesCollapsed = styled.div`
  display: flex;
  position: relative;
  opacity: 0.6;
`;
